import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import RefundListHeader from "../../components/RefundList/RefundListHeader";
import RefundListTable from "../../components/RefundList/RefundListTable";

const RefundVoucherPage = () => {
  return (
    <div className="px-3 py-2">
      <Breadcrumb currentPage="Refund Voucher List" />
      <RefundListHeader />
      <RefundListTable />
    </div>
  );
};

export default RefundVoucherPage;
